import React, { useState } from "react";
import Container from "@mui/material/Container";
import { Button, Grid } from "@mui/material";

import logo from "../../Images/logo.png";

import { Link } from "react-router-dom";

import { ethers } from "ethers";
const Navbar = () => {
  const [errorMessage, setErrorMessage] = useState(null);
  const [defaultAccount, setDefaultAccount] = useState(null);
  const [userBalance, setUserBalance] = useState(null);
  const [connButtonText, setConnButtonText] = useState("Connect Wallet");

  const mybal = Math.ceil(userBalance);

  const connectWalletHandler = () => {
    if (window.ethereum && window.ethereum.isMetaMask) {
      console.log("MetaMask Here!");
      window.ethereum
        .request({ method: "eth_requestAccounts" })
        .then((result) => {
          accountChangedHandler(result[0]);
          setConnButtonText("Wallet Connected");
          getAccountBalance(result[0]);
        })
        .catch((error) => {
          setErrorMessage(error.message);
        });
    } else {
      console.log("Need to install MetaMask");
      setErrorMessage("Please install MetaMask browser extension to interact");
    }
  };
  // update account, will cause component re-render
  const accountChangedHandler = (newAccount) => {
    setDefaultAccount(newAccount);
    getAccountBalance(newAccount.toString());
  };
  const getAccountBalance = (account) => {
    window.ethereum
      .request({ method: "eth_getBalance", params: [account, "latest"] })
      .then((balance) => {
        setUserBalance(ethers.utils.formatEther(balance));
      })
      .catch((error) => {
        setErrorMessage(error.message);
      });
  };

  const chainChangedHandler = () => {
    // reload the page to avoid any errors with chain change mid use of application
    window.location.reload();
  };

  // listen for account changes
  window.ethereum.on("accountsChanged", accountChangedHandler);
  window.ethereum.on("chainChanged", chainChangedHandler);

  return (
    <div>
      <Container>
        <Grid container paddingTop={3}>
          <Grid xs={12} sm={4}>
            <Link style={{ textDecoration: "none" }} to="/">
              <img className="img-fluid" alt="logo" src={logo} />
            </Link>
          </Grid>
          <Grid
            xs={12}
            sm={8}
            className="text-center text-sm-right d-none d-sm-inline-block"
          >
            <Link
              style={{ textDecoration: "none" }}
              href="#"
              className="Rey---Head---Button1 d-none d-sm-inline-block mt-3"
            >
              Trade
            </Link>
            <Link
              style={{ textDecoration: "none" }}
              href="#"
              className="Rey---Head---Button1 d-none d-sm-inline-block mt-3 ml-5"
            >
              contact support
            </Link>
            <Button
              className="Rey---Head---Button d-inline-block px-4 py-3 ml-4"
              onClick={connectWalletHandler}
            >
              {connButtonText}
            </Button>
            <br />
            {/* Balance: {mybal} */}
          </Grid>
        </Grid>
      </Container>
    </div>
  );
};
export default Navbar;
